import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FrameSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FrameSVG;
